import http from "@/utils/http";
/**
 * 获取事项列表
 * @returns {*}
 */
export const queryList = (type, flowKey, pageIndex, searchJson, searchFieldJson) => {
    const URL = {
        draft: '/cooperativeInst/primedList.htm',
        send: '/cooperativeInst/haveHairList.htm',
        ongoing: '/cooperativeInst/haveHairList.htm',
        end: '/cooperativeInst/haveHairList.htm',
        todo: '/cooperativeInst/toDoList.htm',
        done: '/cooperativeInst/haveToDoList.htm',
        copy: '/cooperativeInst/makeCopeList.htm',
        reply: '/cooperativeInst/newReplayList.htm',
    }

    if (searchJson) searchJson = decodeURIComponent(searchJson)
    if (searchFieldJson) searchFieldJson = decodeURIComponent(searchFieldJson)

    const params = {
        searchFieldJson: searchFieldJson,
        searchJson: searchJson,
        tStatus: type,
        flowKey: flowKey,
        pageIndex: pageIndex,
        pageSize: 20,
    }
    return http.post(URL[type], params)
}
/**
 * 删除流程实例
 * @param id 流程实例id
 * @returns {*}
 */
export const deleteInstance = id => http.get('/cooperative/deleteCooperative.htm', {ids: id})
/**
 * 根据流程查询表单信息实例
 * @param id 流程实例id
 * @returns {*}
 */
export const getFormList = params => http.get('/cooperativesearch/queryForms.htm?id=' + params.id + '&type=' + params.type)
/**
 * 根据表单id查询表单字段实例
 * @param id 表单实例id
 * @returns {*}
 */
export const getWordsList = params => http.get('flowcfg/synergy_field/queryListByFormId.htm?formId=' + params.formId + '&type=query')